import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockTickerFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 * Lazy per the block-loading rule: not on the critical rendering path.
 */
export const tickerBlockConfig = {
  name: 'inner-block-ticker',
  component: defineAsyncComponent(() => import('./CmsTickerBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./BaseTicker.vue')),
  fields: blockTickerFields,
} satisfies ModularBlockConfig;
